import React from 'react'
import SnippeSection from './SnippeSection'


export default function LangHtm() {
    let g = "<nav>\n\t<div class=\"leftNav\">\n\t\t//YourCode\n\t</div>\n\t<div class=\"rightNav\">\n\t\t<ul>\n\t\t\t<li>//code</li>\n\t\t\t<li>//code</li>\n\t\t</ul>\n\t</div>\n</nav>"
    return (
        <>
            <h1 className='text-6xl my-color text-white text-center py-3 w-4/5 m-auto font-semibold rounded-3xl my-4 border-2 border-slate-900'>HTML</h1>
            <SnippeSection title="create-nav : Complete Html Navbar" locate="" code={g} />
        </>
    )
} 
